import '../constants/const.css';
import './css/pageLogin.css';

import Button from '../components/buttonBase';

import passON from '../image/passON.png';
import passOFF from '../image/passOFF.png';
import React, { useState, useEffect } from 'react';
import { useApi, REQ_API_LOGIN, JsonResponse } from '../logic/classApi';
import { LoginService, LoginStrageInfo } from '../logic/loginService';
import { showMessage } from '../components/appPane';
import { MESSAGES, ENVIRONMENT, PATH_ROOT } from '../constants/const';

interface ButtonProps {
  onClick: (isLogin: boolean) => void;
  redirect: () => void;
}

const Page: React.FC<ButtonProps> = ({ onClick, redirect }) => {
  // const { postRequestJson, setExcelAPI } = useApi();

  const [userId, setUserId] = useState('');

  const [password, setPassword] = useState('');

  const [enviromentName, setEnviromentName] = useState('');
  const [enviromentText, setEnviromentText] = useState('');

  // ユーザ情報をストレージから破棄
  useEffect(() => {
    LoginService.removeLoginInfo();
  }, []);

  useEffect(() => {
    const enviroment: string = ENVIRONMENT;

    const name = [enviroment === 'LOCAL' ? '-local' : enviroment === 'DEVELOP' ? '-develop' : enviroment === 'STAGING' ? '-staging' : enviroment === 'PRODUCTION' ? '' : '']
      .filter(Boolean)
      .join(' ');

    const text = [
      enviroment === 'LOCAL' ? '（LOCAL環境）' : enviroment === 'DEVELOP' ? '（開発環境）' : enviroment === 'STAGING' ? '（検証環境）' : enviroment === 'PRODUCTION' ? '' : '',
    ]
      .filter(Boolean)
      .join(' ');

    setEnviromentName(name);
    setEnviromentText(text);
  }, []);

  const handleId = (event: any) => {
    setUserId(event.target.value);
  };

  const handlePassword = (event: any) => {
    setPassword(event.target.value);
  };

  const { postRequestJson } = useApi();

  const handleSearchConfirm = async () => {
    let userIdStr: string = String(userId);

    const loginInfo = { userId: userIdStr, password };
    let { payload: response } = await postRequestJson<JsonResponse>(REQ_API_LOGIN, loginInfo);
    console.log(response);

    if (response.sessionId) {
      const storage: LoginStrageInfo = {
        userId: response.userId,
        sessionId: response.sessionId,
        role: response.role,
        branchId: response.mainBranch,
        subBranchId: response.subBranch,
        furnacesCount: response.furnaces,
        userName: response.userName,
        branchName: response.branchName,
        screenUrl: PATH_ROOT,
      };
      LoginService.setLoginInfo(storage);
      onClick(true);
      redirect();
    } else {
      showMessage({ message: MESSAGES.ERROR_AUTH, type: 'error' });
    }
  };

  const handlePassClear = () => {
    const passwordInput: HTMLInputElement | null = document.getElementById('passwordText') as HTMLInputElement;
    const passwordMask: HTMLInputElement | null = document.getElementById('passMask') as HTMLInputElement;
    if (passwordInput.type === 'text') {
      passwordInput.type = 'password';
      passwordMask.src = passOFF;
    } else {
      passwordInput.type = 'text';
      passwordMask.src = passON;
    }
  };

  return (
    <>
      <div className="screen-panel">
        <div className="login-panel">
          <div className="logo-title">{'LOGO' + enviromentText}</div>
          <div className="system-title">ごみ焼却運転計画システム</div>

          <div className="main-panel">
            <hr className={'login' + enviromentName + '-hr'} id="login-hr"></hr>
            <div className="split-panel">
              <input className="user-input" type="text" placeholder="ID" onChange={handleId} />
            </div>

            <div className="split-panel">
              <input className="user-input" id="passwordText" type="password" placeholder="パスワード" onChange={handlePassword} />
              <span onClick={handlePassClear}>
                <img className="pass-mask" src={passOFF} alt="button" id="passMask" width="25px" height="25px"></img>
              </span>
            </div>
            <Button className="login-button" onClick={handleSearchConfirm}>
              ログイン
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Page;
